// src/components/pages/CookiePolicyPage.js
import React from "react";
import "../../styles/legal.css";
import { Helmet } from "react-helmet-async";

export default function CookiePolicyPage() {
  return (
    <>
    <Helmet>
  <title>Cookie Policy – PracVerse</title>
  <link rel="icon" href="/favicon.ico" />
<link rel="shortcut icon" href="/favicon.ico" />
<link rel="apple-touch-icon" href="/favicon.ico" />

  <meta
    name="description"
    content="Learn how PracVerse uses cookies and similar technologies to improve your browsing experience."
  />
  <link rel="canonical" href="https://www.pracverse.com/cookie-policy" />

  <meta property="og:title" content="Cookie Policy – PracVerse" />
  <meta
    property="og:description"
    content="Details about cookies and tracking technologies used on the PracVerse website."
  />
  <meta property="og:url" content="https://www.pracverse.com/cookie-policy" />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Cookie Policy – PracVerse",
      "url": "https://www.pracverse.com/cookie-policy",
      "about": "Cookie Policy"
    })}
  </script>
</Helmet>

    <main className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <h1>Cookie Policy</h1>
          <p>Last updated: 30 November 2025</p>
          <p>
            This Cookie Policy explains how PracVerse uses cookies and similar
            technologies on our website.
          </p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <h2>1. What Are Cookies?</h2>
          <p>
            Cookies are small text files that are stored on your device when you
            visit a website. They help the site remember your actions and
            preferences so that you have a smoother experience.
          </p>

          <h2>2. Types of Cookies We Use</h2>

          <h3>2.1 Essential cookies</h3>
          <p>
            These cookies are necessary for the basic operation of our website
            and cannot be switched off in our systems. They are usually set in
            response to actions you take, such as logging in, filling forms or
            setting privacy preferences.
          </p>

          <h3>2.2 Performance and analytics cookies</h3>
          <p>
            These cookies help us understand how visitors use our website, so we
            can improve content, navigation and overall experience. For example,
            we may use Google Analytics or similar tools to track anonymous usage
            statistics.
          </p>

          <h3>2.3 Functional cookies</h3>
          <p>
            These cookies allow the website to remember choices you make, such
            as your language or region, and provide more personalised features.
          </p>

          <h3>2.4 Marketing or third-party cookies</h3>
          <p>
            Some pages may include embedded content (such as YouTube videos) or
            third-party tools. These services may use their own cookies to track
            usage or personalise content. We do not control these cookies
            directly.
          </p>

          <h2>3. How You Can Control Cookies</h2>
          <p>You can manage cookies in several ways:</p>
          <ul>
            <li>
              Use the cookie banner or settings (if available) to accept or
              reject non-essential cookies.
            </li>
            <li>
              Change your browser settings to block or delete cookies. Most
              browsers allow you to refuse some or all cookies.
            </li>
            <li>
              Regularly clear stored cookies from your browser history.
            </li>
          </ul>
          <p>
            Please note that blocking certain cookies may affect the performance
            of the website or limit some features.
          </p>

          <h2>4. Third-Party Cookies</h2>
          <p>
            We may use third-party services such as analytics, video hosting,
            payment gateways or social media widgets. These providers may set
            their own cookies according to their privacy and cookie policies.
          </p>

          <h2>5. Changes to This Cookie Policy</h2>
          <p>
            We may update this Cookie Policy from time to time to reflect
            changes in technology, law or our practices. Updates will be posted
            on this page with a revised &quot;Last updated&quot; date.
          </p>

          <h2>6. Contact Us</h2>
          <p>
            If you have any questions about how we use cookies, please contact
            us at{" "}
            <a href="mailto:contact@pracverse.com">contact@pracverse.com</a>.
          </p>
        </div>
      </section>
    </main>
    </>
  );
}
